<div class="bg-surface-50 dark:bg-surface-950 px-12 py-20 md:px-12 lg:px-20">
	<div class="flex flex-col gap-8">
		<div class="flex flex-col gap-4 items-center text-center">
			<app-headline-large [title]="content.title"></app-headline-large>
			<div class="flex flex-col gap-4 w-full lg:w-1/2">
				<app-body-large [description]="content.description"></app-body-large>
			</div>
		</div>

		<div class="flex justify-center flex-col md:flex-row gap-8 md:gap-8">
			@for (item of content.copy; track item.title) {
			<div class="bg-primary-800 dark:bg-surface-900 shadow-sm p-2 flex flex-col gap-4">
				<img
					[src]="item.image.src"
					[alt]="item.image.alt"
					class="w-full"
					loading="lazy" />
				<div class="flex justify-center items-center gap-6">
					<div class="flex flex-col justify-center gap-2">
						<app-title
							[copy]="item.title"
							size="small"
							class="text-surface-100!"></app-title>
					</div>
				</div>
			</div>
			}
		</div>
	</div>
</div>
